import { Collapse, Flex, message, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { draftapi } from "../../services/draftapi";
import { utcDateTimeToLocalPA } from "../../shared";

const { Text } = Typography;
const CallBackHistory = ({ editDraft }) => {
  const [callhistory, setCallHistory] = useState(null);

  useEffect(() => {
    if (editDraft) {
      GetCallHistory();
    }
  }, [editDraft]);

  const GetCallHistory = async () => {
    try {
      const result = await draftapi?.getCallHistory(editDraft?.id);
      if (result) {
        setCallHistory(result?.data);
      }
    } catch (error) {
      console.log(error);
      message.error(error || "Failed to load draft call history");
    }
  };
  return (
    <Flex vertical gap={10}>
      <Collapse
        items={[
          {
            key: "1",
            label: "Call History",
            children: (
              <Flex>
                {callhistory?.length > 0 ? (
                  <>
                    {callhistory?.map((history) => (
                      <Tag key={history?.id}>
                        {utcDateTimeToLocalPA(history?.call_again)}
                      </Tag>
                    ))}
                  </>
                ) : (
                  <Flex justify="center" align="center" className="w-100">
                    <Text italic className="fs-12">
                      No Call Again History Available
                    </Text>
                  </Flex>
                )}
              </Flex>
            ),
          },
        ]}
        expandIconPosition={"end"}
      />
    </Flex>
  );
};

export { CallBackHistory };
